async function checkStockForVariant(variantId, containerSelector) {
  const container = document.querySelector(containerSelector);
  if (!container) {
    console.error(`Container not found: ${containerSelector}`);
    return;
  }

  const storesContainer = container.querySelector(".stores");
  if (!storesContainer) {
    console.error("Stores container not found in the container.");
    return;
  }

  storesContainer.classList.add("loading");

  try {
    const response = await fetch(`https://shopify.retailexpress.com.au/api/shopify_stores/beyond-skate-city/outlets?variant_ids=${variantId}`);
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();

    data.outlets.forEach((outlet) => {
      const storeElement = storesContainer.querySelector(`.store-item[data-store="${outlet.name}"]`);

      if (storeElement) {
        const stockElement = storeElement.querySelector(".store-item__stock");
        if (stockElement) {
          const stock = outlet.stock[variantId] || 0;
          stockElement.dataset.stock = stock;

          if (stock > 1) {
            stockElement.textContent = "In Stock";
            stockElement.classList.remove("low", "none");
          } else if (stock === 1) {
            stockElement.textContent = "1 Left";
            stockElement.classList.add("low");
            stockElement.classList.remove("none");
          } else {
            stockElement.textContent = "Out of Stock";
            stockElement.classList.add("none");
          }
        }
      }
    });
  } catch (error) {
    console.error("Error fetching stock data:", error);

    const stockElements = storesContainer.querySelectorAll(".store-item__stock");
    stockElements.forEach((element) => {
      element.textContent = "Error checking stock";
      element.classList.add("none");
    });
  } finally {
    storesContainer.classList.remove("loading");
  }
}
